import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { Bar } from 'react-chartjs-2'
import { formatNumber, toKSEK } from '../../helpers'

@observer
class VerticalBar extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        /**
         * @note
         * React-chartjs-2 can not read Observable array, parse + stringify fix the issue.
         */
        const chartData = JSON.parse(JSON.stringify(this.props.chartOpt.data))
        const chartOpt  = JSON.parse(JSON.stringify(this.props.chartOpt.options))
        const self = this;

        chartOpt.tooltips.callbacks = {
            label: function(tooltipItem, data) {
                return 'Ordrar: ' + data.datasets[tooltipItem.datasetIndex].orders[tooltipItem.index] + ' st'
            },
            beforeLabel: function(tooltipItem, data) {
                if (self.props.valuesAsKSEK) {
                    return 'Värde: ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + ' tkr';  
                } else {
                    return 'Värde: ' + formatNumber(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])  
                }
            },
            afterLabel: function(tooltipItem, data) {
                return 'Tid: ' + Math.ceil(data.datasets[tooltipItem.datasetIndex].productionTimeSeconds[tooltipItem.index] / 3600) + ' h'
            },
        }        

        return <div className="chart-grouped">
            <Bar
                data={ chartData }
                options={ chartOpt }
            />
        </div>
    }
}

export default VerticalBar
